export default __webpack_public_path__ + "static/media/windows.f2182186.svg";